import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/HomeView.vue'
import SuccessCaseDetailView from '@/views/SuccessCaseDetailView.vue'
import ColumnDetailView from '@/views/ColumnDetailView.vue'
import MediaContentDetailView from '@/views/MediaContentDetailView.vue'
import MediaCategoryListView from '@/views/MediaCategoryListView.vue'
import MediaSearchView from '@/views/MediaSearchView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    // 메인은 신규 퍼블리싱(Figma 252:2352)으로 교체했다.
    { path: '/', name: 'home', component: () => import('@/views/MediaHubNewView.vue') },
    // 교체 전 메인. 비교용으로 남겨 둔다 — 확정되면 HomeView.vue 와 함께 지운다.
    { path: '/legacy', name: 'media-home-legacy', component: HomeView },
    // 검수 때 쓰던 주소. 링크가 남아 있을 수 있어 메인으로 넘긴다.
    { path: '/new', redirect: { name: 'home' } },
    // 목록 화면 하나로 전체 · 카테고리별 · 검색 세 가지를 다 쓴다(퍼블리싱이 하나다).
    { path: '/new/all', name: 'media-list-new', component: () => import('@/views/MediaListNewView.vue') },
    {
      path: '/new/all/:categoryCode',
      name: 'media-category-new',
      component: () => import('@/views/MediaListNewView.vue'),
    },
    {
      path: '/new/search',
      name: 'media-search-new',
      component: () => import('@/views/MediaListNewView.vue'),
    },
    {
      path: '/success-cases/:id',
      name: 'success-case-detail',
      component: SuccessCaseDetailView,
      props: true,
    },
    {
      path: '/columns/:id',
      name: 'column-detail',
      component: ColumnDetailView,
      props: true,
    },
    {
      path: '/media/categories/:categoryCode',
      name: 'media-category',
      component: MediaCategoryListView,
      props: true,
    },
    {
      path: '/search',
      name: 'media-search',
      component: MediaSearchView,
    },
    {
      path: '/media/:homepageContentCode',
      name: 'media-content-detail',
      component: MediaContentDetailView,
      props: true,
    },
  ],
})

export default router
